export default {
  SET_END_POINT_CONFIG(state, data) {
    state.endPointConfig = data
  },
}
